<template>
  <div style="margin-top:20px">
    <el-form
      ref="form"
      label-width="80px"
      :model="form"
    >
      <el-row>
        <div class="grid-content bg-purple">
          <el-form-item
            label="运费总金额"
            style="margin-right:15px"
          >
            <el-input
              v-model="form.freightAmount"
              :disabled="true"
            />
          </el-form-item>
        </div>
        <div class="grid-content bg-purple">
          <el-form-item
            label="开票总金额"
            style="margin-right:15px"
          >
            <el-input
              v-model="form.invoiceAmount"
              :disabled="true"
            />
          </el-form-item>
        </div>
        <div class="grid-content bg-purple">
          <el-form-item
            label="发票号码"
            style="margin-right:15px"
          >
            <el-input
              v-model="form.invoiceNumber"
              :disabled="true"
            />
          </el-form-item>
        </div>
        <div class="grid-content bg-purple">
          <el-form-item
            label="发票抬头"
            style="margin-right:15px"
          >
            <el-input
              v-model="form.invoiceTitle"
              :disabled="true"
            />
          </el-form-item>
        </div>
        <div class="grid-content bg-purple">
          <el-form-item
            label="税务登记证号"
            style="margin-right:15px"
          >
            <el-input
              v-model="form.taxRegistrationNumber"
              :disabled="true"
            />
          </el-form-item>
        </div>
        <div class="grid-content bg-purple">
          <el-form-item
            label="发票图片"
            style="margin-right:15px"
          >
            <el-input
              v-model="form.invoiceImg"
              :disabled="true"
            />
          </el-form-item>
        </div>
        <div class="grid-content bg-purple">
          <el-form-item
            label="发票状态"
            style="margin-right:15px"
          >
            <el-input
              v-model="form.invoiceStatus"
              :disabled="true"
            />
          </el-form-item>
        </div>
        <div class="grid-content bg-purple">
          <el-form-item
            label="发票开具时间"
            style="margin-right:15px"
          >
            <el-input
              v-model="form.invoiceIssuedTime"
              :disabled="true"
            />
          </el-form-item>
        </div>
        <div class="grid-content bg-purple">
          <el-form-item
            label="发票确认时间"
            style="margin-right:15px"
          >
            <el-input
              v-model="form.invoiceConfirmTime"
              :disabled="true"
            />
          </el-form-item>
        </div>
        <div class="grid-content bg-purple">
          <el-form-item
            label="开票备注"
            style="margin-right:15px"
          >
            <el-input
              v-model="form.invoiceRemark"
              :disabled="true"
            />
          </el-form-item>
        </div>
      </el-row>
    </el-form>
  </div>
</template>
<script>
import request from '@/utils/request'

export default {
  name: 'Child',
  data() {
    return {
      form: {
        code: '',
        askUserCode: '',
        freightAmount: '',
        invoiceAmount: '',
        invoiceNumber: '',
        invoiceMessageCode: '',
        invoiceTitle: '',
        taxRegistrationNumber: '',
        invoiceImg: '',
        invoiceStatus: '',
        invoiceFrom: '',
        invoiceIssuedTime: '',
        invoiceConfirmTime: '',
        invoiceRemark: '',
        step: ''
      }
    }
  },
  created() {},
  methods: {
    // 获取页面信息
    getInfo(code) {
      request({ url: `/ntocc-basic-api/invoice/${code}`, method: 'get' }).then(response => {
        this.form = response.data
        this.$message({ message: response.msg, type: 'success' })
      })
    }
  }
}
</script>
<style lang="scss" scoped>
    .dialog-footer {
        margin-top: 50px;
    }
</style>
